/**
 * Formata número com separador de milhar (pt-BR)
 * 50000 → "50.000"
 */
export function formatNumber(value: number | string | null | undefined): string {
  if (value === null || value === undefined || value === '') return ''
  const num = typeof value === 'string' ? parseInt(value.replace(/\D/g, '')) : value
  if (isNaN(num)) return ''
  return num.toLocaleString('pt-BR')
}

/**
 * Remove formatação e retorna só dígitos
 * "50.000" → "50000"
 */
export function cleanNumber(value: string): string {
  return value.replace(/\D/g, '')
}

/**
 * Máscara de input: formata enquanto digita
 * Uso: onChange={e => setValue(maskNumber(e.target.value))}
 */
export function maskNumber(value: string): string {
  const digits = value.replace(/\D/g, '')
  if (!digits) return ''
  return parseInt(digits).toLocaleString('pt-BR')
}

/**
 * Converte valor mascarado para número
 * "50.000" → 50000
 */
export function unmaskNumber(value: string): number | null {
  const digits = value.replace(/\D/g, '')
  if (!digits) return null
  return parseInt(digits)
}
